import ajax from 'Site/js/util/ajax.fetch';
import CheckBoxes from 'Site/component/CheckBoxes.vue';
import coverImageMixin from 'Site/js/mixin/cover.image';
import dropdownDirective from 'Site/directive/dropdown';
import Editable from 'Site/component/Editable.vue';
import Invite from 'Site/component/SelectFriends.vue';
import Message from 'Messaging/component/Message.vue';
import store from 'Site/js/store';
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';

export default function () {
    new Vue({ /* eslint no-new:0 */
        el: '#event-header',
        name: 'eventHeader',
        store,
        components: {
            CheckBoxes,
            Editable,
            Invite,
            Message
        },
        computed: {
            ...mapState({
                eventAjaxParams: state => ({ url: 'event', id: state.config.data.id }),
                notifications: state => state.config.data.notifications,
            })
        },
        data() {
            return {
                messageStatuses: [1],
                showInviteFriends: false,
                showMessageAttendees: false
            };
        },
        directives: {
            dropdown: dropdownDirective
        },
        methods: {
            ...mapActions(['notify', 'showConfirm']),
            changeCoverImage(coverImage) {
                this.showCoverImageModal = false;
                this.coverImage = coverImage.url;
                if (coverImage.upload) {
                    this.notify({ msg: this.t.cover_image_awaiting_approval });
                    return;
                }
                let params = { id: this.id, cover: coverImage.id };
                if (coverImage.site) {
                    params = { id: this.id, theme: coverImage.name };
                }
                ajax.update('event', params).then(() => {
                    this.notify({ msg: this.t.cover_image_updated });
                });
            },
            deleteEvent(text, url, redirect) {
                this.showConfirm({
                    text,
                    callback: () => {
                        ajax.delete(url).then(() => {
                            window.location = redirect;
                        });
                    }
                });
            },
            inviteCallback(users) {
                ajax.create('eventInvite', { users }).then((response) => {
                    this.notify({ msg: response.message });
                }).catch(({ response }) => {
                    response.then((error) => {
                        this.notify({ type: 'error', msg: error.message });
                    });
                });
            },
            messageCallback({ subject, body }) {
                ajax.create('eventMessage', {
                    subject,
                    recipients: this.messageStatuses,
                    body
                }).then((response) => {
                    this.notify({ msg: response.message });
                });
            },
            showInviteModal() {
                this.showInviteFriends = true;
            },
            showMessageModal() {
                this.showMessageAttendees = true;
            },
            toggleNotifications() {
                ajax.update(
                    'eventAttend',
                    { id: this.notifications.id, type: 'notification', notifications: this.notifications.enabled ? 0 : 1 }
                ).then((response) => {
                    this.notify({ msg: response.message });
                });
                this.notifications.enabled = !this.notifications.enabled;
            }
        },
        mixins: [coverImageMixin]
    });
}
